<template>
  <BaseModal :modal-name="name" max-width="max-w-4xl">
    <div class="flex flex-col items-center text-center">
      <p
        class="text-[28px] font-medium leading-[42px] tracking-tight text-darkestGray"
      >
        Szanowny Użytkowniku, według regulaminu
        <nuxt-link
          to="/static/regulamin"
          target="_blank"
          class="cursor-pointer text-blue underline"
        >
          www.alab.pl</nuxt-link
        >
        wyłącznie pełnoletni użytkownicy mają możliwość posiadania dostępu do
        konta pacjenta. Dostęp do wyników z poziomu konta pacjenta dla osób
        niepełnoletnich jest możliwy z poziomu konta pełnoletniego opiekuna
        prawnego w zakładce „Twoje dzieci”
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
const name = 'loginAgeExceptionModal'
</script>
